import isNil from 'lodash/isNil';

/**
 * Returns the years of experience of a provider
 *
 * @param {Object} provider
 * @return {Number}
 */
export default function getProviderExperience(provider) {
  if (isNil(provider) || isNil(provider.lender_since)) {
    return 0;
  }

  return (new Date()).getFullYear() - provider.lender_since;
}
